module.exports = __webpack_public_path__ + "static/media/9_I wish you enough_AF.43b65366.txt";